import { NgModule } from '@angular/core';
import { IconRatingComponent } from './icon-rating.component';

@NgModule({
  exports: [IconRatingComponent],
  imports: [IconRatingComponent],
})
export class FmntsRatingModule {}
